
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3837|4306)5$/.test(chunkId);
},
rootOutputDir: "",

    };
}
